export default "__VITE_ASSET__qYf_UK89__"